import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SURVEYS } from '@/api/endpoints';
import type { SurveyAnswerRequest } from '@/types/survey';
import { ErrorMessage, logRequestError } from '@/utils/errors';
import { joinPath } from '@/utils/global';

interface Params {
  onError: () => void;
}

export const useAnswerSurveyQuestion = ({ onError }: Params) => {
  const { mutate: answerQuestion, isPending: isAnswering } = useMutation({
    mutationFn: (answer: SurveyAnswerRequest) =>
      apiClient.post(
        `${joinPath(API_SURVEYS, answer.surveyId)}/answers`,
        answer,
      ),
    onError: (error) => {
      logRequestError(ErrorMessage.AnswerSurveyQuestion, error);
      onError();
    },
  });

  return { answerQuestion, isAnswering };
};
